export function handleCruzamentoStrategy(plotData, viewConfigData) {
  if (!viewConfigData.graficos.length || !viewConfigData.graficos[0].checked) {
    return null;
  }

  const newQuestionList = plotData.data.perguntas_principais[0].perguntas_cruzadas.filter(
    (crossQuestion) =>
      viewConfigData.graficos[0].perguntas.some(
        (q) => q.id_pergunta === crossQuestion.id && q.checked
      )
  );


  const newData = {
    ...plotData,
    data: {
      ...plotData.data,
      perguntas_principais: [
        {
          ...plotData.data.perguntas_principais[0],
          perguntas_cruzadas: [...newQuestionList.map(o => ({ ...o }))],
        },
      ],
    },
  };

  return newData;
}
